<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <CButton color="success" @click="createProduct()" class="mb-4"><CIcon name="cil-plus" height="48"/>{{ $t("Voucher.AddVoucher") }}</CButton>
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              :items-per-page="100"
              pagination
              columnFilter
              tableFilter
              sorter
            >
              <template #coupon="{item}">
                <td>
                  <span v-if="item.type=='Code'">{{item.coupon}}</span>
                  <span v-else>--</span>
                </td>
              </template>
              <template #amount="{item}">
                <td>
                  <strong v-if="item.type=='Code'">{{item.amount}}<sup>DT</sup></strong>
                </td>
              </template>
              <template #appearency_pourcentage="{item}">
                <td>
                  <strong v-if="item.type=='Product'">{{item.appearency_pourcentage}}%</strong>
                  <strong v-else>--</strong>
                </td>
              </template>

              <template #status="{item}">
                <td>
                  <span :class="'badge badge-succes badge-'+item.status">{{item.status}}</span>
                </td>
              </template>
              
              <template #add="{item}">
                <td>
                  <span>{{item.created_at}}</span>
                </td>
              </template>
              <template #modify="{item}">
                <td>
                  <span>{{item.updated_at}}</span>
                </td>
              </template>
              
              <template #Options="{item}">
                <td class="text-right">
                  <!-- <CButton color="primary" @click="showNote( item.id )" class="mr-2"><CIcon name="cil-center-focus" height="48"/> </CButton> -->
                  <CButton color="warning" @click="$router.push('vouchers/'+item.id+'/update')" class="mr-2"><CIcon name="cil-pencil" height="48"/> </CButton>
                  <CButton v-if="you!=item.id" color="danger" @click="deleteToast( item )"><CIcon name="cil-trash" height="48"/> </CButton>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
    <vue-confirm-dialog></vue-confirm-dialog>
  </CRow>
</template>

<script>
import { voucherService } from '../../_services';
import moment from 'moment'

export default {
  name: 'Notes',
  data: () => {
    return {
      items: [],
      /*
      fields: [
        {key: 'author'},
        {key: 'title'},
        {key: 'content'},
        {key: 'applies_to_date'},
        {key: 'status'},
        {key: 'note_type'},
        {key: 'show'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      */
      fields: [
        {key: 'type', label: 'Type'},
        {key: 'coupon', label: 'Coupon'},
        {key: 'amount', label: 'Montant'},
        {key: 'qte', label: 'Quantité'},
        {key: 'appearency_pourcentage', label: 'Pourcentage \n d\'apparence'},
        {key: 'status', label: 'Etat'},
        {key: 'add', label: 'Date d\'ajout'},
        {key: 'modify', label: 'Dérniere modification'},
        {key: 'Options', label: 'Options'},
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  computed: {
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    noteLink (id) {
      return `notes/${id.toString()}`
    },
    editLink (id) {
      return `product/${id.toString()}/edit`
    },
    showNote ( id ) {
      const noteLink = this.noteLink( id );
      this.$router.push({path: noteLink});
    },
    editNote ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteNote ( id ) {
      this.loader = this.$loading.show();
    
      voucherService.delete(id).then(function(data){
        this.items = data.data.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY HH:mm')
            obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY HH:mm')
            return obj
        });
      }.bind(this)).finally(
          function () {
            this.loader.hide();
          }.bind(this)
      );
    },
    createProduct () {
      this.$router.push({path: 'vouchers/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getProducts (){
      let self = this;
      this.loader = this.$loading.show();
      voucherService.getAll().then(function (response) {
        self.items = response.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY HH:mm')
            obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY HH:mm')
            return obj
        });
      }).finally(function () {
        this.loader.hide();
      }.bind(this));
    },
    deleteToast(item){
      this.$confirm(
        {
          title: `Confirmation!`,
          message: 'êtes-vous sûr de supprimer ce coupon?',
          button: {
            no: 'Annuler',
            yes: 'Supprimer'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm 
          */
          callback: confirm => {
            if (confirm) {
              this.deleteNote(item.id)
            }
          }
        }
      )
    }
  },
  mounted: function(){
    this.getProducts();
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.badge{
  color: #fff;
}
.badge-Active{
  background: green;
}
.badge-Epuisé{
  background: rgb(175, 8, 8);
}
.badge-Arrêté{
  background: rgb(180, 192, 18);
}
</style>
